import { useState } from "react";
import DashboardLayout from "components/templates/DashboardLayout";
import Topnav from "components/organisms/Topnav";
//import Grid from "@mui/material/Grid";
import React from "react";
import { Grid, Row, Col } from "rsuite";
import "rsuite/dist/rsuite.min.css";
import TablePanel from "pages/history/components/TablePanel";
import TablePanelAlert from "pages/history/components/TablePanelAlert";
import MDBox from "components/atoms/MDBox";
import { Card, Text, DateRangePicker } from "rsuite";
import { FaCalendar } from "react-icons/fa";
import "rsuite/dist/rsuite.min.css";

function ShowHistory() {
  const [startUnixts, setStartUnixts] = useState(null);
  const [endUnixts, setEndUnixts] = useState(null);

  return (
    <DashboardLayout>
      <Topnav title={"History Records"} />
      <MDBox mb={4} />
      <Grid fluid>
        <Row gutter={[9, 24]}>
          <Col span={{ xs: 24 }}>
            <Card size="md" shaded>
              <Card.Header
                backgroundColor={"#5D5D62"}
                style={{ paddingLeft: "20px", paddingBottom: "10px" }}
              >
                <Text
                  size="md"
                  style={{
                    textAlign: "left",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Select a date range
                </Text>
              </Card.Header>
              <Card.Body>
                <DateRangePicker
                  format="dd MMM yyyy hh:mm:ss aa"
                  showMeridiem
                  caretAs={FaCalendar}
                  ranges={[]}
                  onChange={(value) => {
                    if (value) {
                      setStartUnixts(value[0].getTime());
                      setEndUnixts(value[1].getTime());
                    }
                  }}
                  onClean={() => {
                    setStartUnixts(null);
                    setEndUnixts(null);
                  }}
                />
              </Card.Body>
            </Card>
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 1"}
              collectionName={"sstd1comb"}
              startUnixts={startUnixts}
              endUnixts={endUnixts}
              backgroundColor="#0F9ED5"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 2"}
              collectionName={"sstd2comb"}
              startUnixts={startUnixts}
              endUnixts={endUnixts}
              backgroundColor="#4EA72E"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 3"}
              collectionName={"sstd3comb"}
              startUnixts={startUnixts}
              endUnixts={endUnixts}
              backgroundColor="#0F9ED5"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanel
              title={"SSTD Outlet 4"}
              collectionName={"sstd4comb"}
              startUnixts={startUnixts}
              endUnixts={endUnixts}
              backgroundColor="#4EA72E"
            />
          </Col>
          <Col span={{ xs: 24 }}>
            <TablePanelAlert
              title={"ALERTS"}
              collectionName={"alerts"}
              startUnixts={startUnixts}
              endUnixts={endUnixts}
              backgroundColor="#0F9ED5"
            />
          </Col>
        </Row>
      </Grid>
    </DashboardLayout>
  );
}

export default ShowHistory;
